/**
 * useCabIdAccess · who may see the CAB-ID issuance/claim program.
 *
 * The program is globally off (CAB_ID_ENABLED=false) until launch, but we want
 * platform admins (Cipher & Row staff: Jack, Louis, QA) to dogfood the full
 * flow now. This gate returns true when the global flag is on OR the signed-in
 * user is a platform admin. Everyone else keeps the "coming soon" experience.
 *
 * Fails closed while the role resolves so the program never flashes for a
 * non-admin. UI affordance only; the backend (RLS + edge functions) is the real
 * boundary.
 */

import { CAB_ID_ENABLED } from "@/lib/feature-flags";
import { useRequireRole } from "@/hooks/useRequireRole";

export function useCabIdAccess(): { allowed: boolean; loading: boolean } {
  const { hasRole: isPlatformAdmin, loading } = useRequireRole("admin");
  return { allowed: CAB_ID_ENABLED || isPlatformAdmin, loading };
}
